import $ from 'jquery';
import { win } from '@rei/browser-shim';

// Cache Ajax Data
const cachedAjaxResults = {};
let sessionStorageEnabled = false;

const useSessionStorage = (boolean) => {
  sessionStorageEnabled = boolean;
};

// transfers sessionStorage from one tab to another
const syncSessionStorage = (event) => {
  const winEvent = !event ? win.event : event; // IE Handling for Event

  if (!winEvent.newValue) {
    return;
  }

  if (winEvent.key === 'getSessionStorage') {
    // Request from open tab
    localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    // Cleanup after sending to other tab
    localStorage.removeItem('sessionStorage');
  } else if (winEvent.key === 'sessionStorage' && !sessionStorage.length) {
    // Other open tab saved data, loop and store into current tab sessionStorage
    const data = JSON.parse(winEvent.newValue);
    Object.keys(data).forEach((key) => {
      sessionStorage.setItem(key, data[key]);
    });
  }
};

const triggerSessionStorageSync = () => {
  // Triggers Event by Saving into localStorage to Sync sessionStorage
  if (!sessionStorage.length) {
    localStorage.setItem('getSessionStorage', 'sessionStoragePlacebo');
    localStorage.removeItem('getSessionStorage', 'sessionStoragePlacebo');
  }
};

// Check if Local/Session Storage is supported by browser
let storageSupport = false;
if (typeof (Storage) !== 'undefined') {
  storageSupport = true;
  // listen for changes to localStorage
  if (win.addEventListener) {
    win.addEventListener('storage', syncSessionStorage, false);
  } else {
    win.attachEvent('onstorage', syncSessionStorage);
  }
  // Trigger Sync on Load If Supported
  triggerSessionStorageSync();
}

const clearSessionStorage = () => {
  sessionStorage.clear();
};

const ajax = (restUrl, successCallback, errorCallback) => {
  // Check for JS Cache, and check session storage if no JS Cache
  let cachedData = cachedAjaxResults[restUrl];

  if (!cachedData && storageSupport && sessionStorageEnabled) {
    const sessionStorageString = localStorage.getItem(restUrl);
    const sessionStoredData = JSON.parse(sessionStorageString);
    if (sessionStoredData) {
      cachedData = sessionStoredData;
    }
  }

  if (cachedData) {
    successCallback(cachedData, restUrl);
  } else {
    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: restUrl,
      context: this,
      success: (data) => {
        successCallback(data, restUrl);
        // For speed, store in JS memory first then sessionStorage
        cachedAjaxResults[restUrl] = data;
        if (storageSupport && sessionStorageEnabled) {
          const dataString = JSON.stringify(data);
          localStorage.setItem(restUrl, dataString);
          triggerSessionStorageSync();
        }
      },
      error: (x, e) => {
        const errorObj = {};
        errorObj.event = e;
        errorObj.x = e;
        errorObj.status = x.status;
        errorObj.message = 'Nothing Found';
        if (errorObj.status === 0) {
          errorObj.message = 'You are offline. Please check your connection.';
        } else if (errorObj.status === 404) {
          errorObj.message = 'Requested URL not found.';
        } else if (errorObj.status === 500) {
          errorObj.message = 'Internal Server Error';
        } else if (errorObj.event === 'parsererror') {
          errorObj.message = 'Request Failed';
        } else if (errorObj.event === 'timeout') {
          errorObj.message = 'Request Timed Out.';
        } else {
          errorObj.message = `Unknown Error: ${x.responseText}`;
        }
        errorCallback(errorObj);
      },
    });
  }
};

export default {
  ajax,
  cachedAjaxResults,
  useSessionStorage,
  clearSessionStorage,
};
